export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_DONE = 'REFRESH_TOKEN_DONE';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_DONE = 'LOGOUT_DONE';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';
export const LOGIN = 'LOGIN';
export const LOGIN_DONE = 'LOGIN_DONE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
//# sourceMappingURL=actionTypes.js.map